import BeardItemCard from "./BeardItemCard"
import Loading from "~/components/Loading";

export default function BeardSubscriptionsList({ items = [], unviewed = [], itemsEmpty = [] }) {

    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const queryClient = ReactQuery.useQueryClient()

    function handleAction(e, item, action) {
        e.preventDefault();

        if (action.slice(0, 1) === '/') window.location = action;
        if (action === 'view') window.location = `/subscriptions/${item.id}`;

        if (action === 'delete') {
            const callback = () => {
                setIsSubmitting(true)
                subscriptionAction.deleteSubscription({id: item.id})
                    .then(response => {
                        queryClient.invalidateQueries(['beard', 'items', 'subscriptions'])
                        queryClient.invalidateQueries(['beard', 'counts'])
                    })
                    .catch((error) => {
                        console.error(error)
                    })
                    .finally(() => {
                        setIsSubmitting(false)
                    })
            }
            confirmPopup(tMsg('Вы уверены, что хотите отменить подписку?'), callback);
        }
    }

    return <React.Fragment>
        <Loading active={isSubmitting} absolute={true} />
        {items.length > 0 && items.map(item => <BeardItemCard key={`${item.id}-${item.code}`} item={item} isNew={unviewed.includes(item.id)} onActionPress={handleAction} />)}
        {items.length === 0 && itemsEmpty.map(item => <BeardItemCard key={`${item.id}-${item.code}`} item={item} onActionPress={handleAction} />)}
    </React.Fragment>
}
